<template>
    <div class="Page">
        <!--Banner-->
        <section class="">
            <div class="banner">
                <h1 class="PageTitle" style="">FINANCEMENT</h1>
            </div>
            <div class="orangeStripe"></div>
        </section>
            <!--section bgText-->
        <section>
            <v-row class="bgText">
            <v-row>
                <p>Chez Réseau Dynamique, notre objectif est de vous satisfaire et de vous supporter dans l'atteinte de vos objectifs d'affaires. Nous sommes persuadés qu'en choisissant un camion de Réseau Dynamique et en optant pour un service après-vente hors pair vous aurez tout en main pour réussir.</p>
            </v-row>
            </v-row>
        </section>
        <!--Futur-->
        <section>
            <v-row>
                <v-col cols="12" md="6" style="padding: 0px;">
                    <div class="futurBG">
                        <div class="futurAlignText">
                            <v-row><v-col><h2 class="sectionTitle futurTitle">Financement concurrentiel</h2></v-col></v-row>
                            <v-row><v-col><p class="futurText">Que vous vous dotiez d'un camion neuf ou d'occasion ou encore d'un lot de camions, vous trouverez satisfaction parmi notre vaste gamme de produits de financement concurrentiels. Nous travaillons avec les meilleurs fournisseurs de services financiers afin de dénicher avec vous le plan de financement qui fera progresser votre entreprise.</p></v-col></v-row>
                            <v-row><v-col><p class="futurText">Nous sommes persuadés que vous faites le meilleur choix pour le futur de votre entreprise en choisissant un camion de Réseau Dynamique. </p></v-col></v-row>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" md="6" style="padding: 0px;" class="futurImg">
                    <v-row>
                        <v-col  style="height: 400px; overflow: hidden; display: flex; align-items: center; justify-content: center;">
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </section>
        <section>
            <div class="orangeStripe"></div>
            <form ref="formFunding" role="form" method="POST" action="https://reseaudynamique.com/ressources/api/emails.php" @submit.prevent="validateAndSubmit"> <!-- action="/<?php echo $NOMPAGE; ?>" --> 
                <input type="hidden" id="emailId" name="emailId" value="5">
                <input v-if="this.form.truckNew" type="hidden" id="truckNew" name="truckNew" value="1">  
                <v-row id="fourthBloc" class=" BGBloc4">
                    <v-col cols="12"><p class="electrikText">Formulaire pour obtenir un financement pour mon camion </p></v-col> 
                    <v-row class="grid boxForm form">
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="nom" id="nom" type="text" placeholder="Nom complet" class="" v-model="form.nom" required>  
                        </v-col>                        
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="stock" id="stock" type="text" placeholder="Numéro de série" class="" v-model="form.serialNumber" required> 
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="model" id="model" type="text" placeholder="Modèle" class=""  v-model="form.model" required>  
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="idInventory" id="idInventory" type="text" placeholder="No d’inventaire" class="" v-model="form.idInventory" required> 
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="address" id="address" type="text" placeholder="Adresse" class="" v-model="form.address" required> 
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="town" id="town" type="text" placeholder="Ville" class="" v-model="form.town" required> 
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm">
                            <select name="province" id="province" v-model="form.province" class="" required>
                                <option value="Quebec">Québec</option>
                                <option value="Alberta">Alberta</option>
                                <option value="Colombie-Britannique">Colombie-Britannique</option>
                                <option value="Ile-du-Prince-Édouard">Île-du-Prince-Édouard</option>
                                <option value="Manitoba">Manitoba</option>
                                <option value="Nouveau-Brunswick">Nouveau-Brunswick</option>
                                <option value="Nouvelle-Écosse">Nouvelle-Écosse</option>
                                <option value="Nunavut">Nunavut</option>
                                <option value="Ontario">Ontario</option>
                                <option value="Saskatchewan">Saskatchewan</option>
                                <option value="Terre-Neuve-et-Labrador">Terre-Neuve-et-Labrador</option>
                                <option value="TerritoiresDuNord-Ouest">Territoires du Nord-Ouest</option>
                                <option value="Yukon">Yukon</option>
                            </select>
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="postalCode" id="postalCode" type="text" placeholder="A1A 1A1" class="" v-model="form.postalCode" @input="formatPostalCode" maxlength="7" required>
                            <p v-if="errors.postalCode" class="errorMsg">{{ errors.postalCode }}</p>
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="email" id="email" type="email" placeholder="Courriel" class="" v-model="form.email" required>
                            <p v-if="errors.email" class="errorMsg">{{ errors.email }}</p>
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="telephone" id="telephone" type="tel" placeholder="(514) 555-1234" class="" v-model="form.telephone" @input="formatTelephone" required>
                            <p v-if="errors.telephone" class="errorMsg">{{ errors.telephone }}</p>
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <select name="succursale" id="succursale" v-model="form.succursale" class="" required>
                                <option value="" disabled>Choisissez votre succursale</option>
                                <option v-for="(dealer, key) in dealers" :key="key" :value="dealer.town + ' - ' + dealer.name">{{ dealer.town }} - {{ dealer.name }}</option>
                            </select>
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm">
                            <input name="comment" id="comment" type="text" placeholder="Commentaire" class="" v-model="form.comment" required>
                        </v-col>

                    </v-row>
                    <button type="submit" name="btnSendMail" id="btnSendMail" value="Envoyer" style=""><a>Soumettre</a></button>
                    <h2 v-if="sendForm == true" class="electrikText">Votre demande a bien été envoyée</h2>
                </v-row>
            </form>
        </section>
    </div>
</template>
<style scoped>
    .PageTitle { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); text-align: center; }
    .banner { position: relative; height: 400px; background-image: url('../../public/ressources/images/career/banner.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
    .bgText {background-color: rgb(var(--ligthGray)); padding: 100px;}
    .futurImg { background-image: url('../../public/ressources/images/career/citation.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
    .futurBG { position: relative; width: 100%; background-color: black; padding: 0px 50px; height: 100%; }
    .futurAlignText { position: relative; top:50%; left: 50%; transform: translate(-50%,-50%);}
    .futurTitle { color: rgb(var(--primary)); font-family: TxtOffBDI; text-transform: uppercase;  }
    .futurText { font-family: TxtOffRe; margin-top: 20px; color: white; }
    /*Region section 3*/
        .electrikText { text-align: center; color: #fff; padding: 20px 0px; font-size: 24px; font-weight: 100; line-height: normal;}
        .BGBloc4 {position:relative;  height: 100%; padding: 10px 0px 10px 0px; background-image: url('../../public/ressources/images/truckElectrik/bloc3BG.jpg'); background-repeat: no-repeat; background-size: cover; background-position: center center;}
        .boxForm { padding: 0px 350px; }
        .realization { padding: 25px 0px; }
        .form input { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .form select { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .form .v-text-field input { color: white; background-color: rgba(17,17,17,1) !important; padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .inputForm { padding: 20px; }
        #ElectrikPage a {text-decoration: none; color:white;}
        #fourthBloc { padding: 100px 0px !important; }
        #fourthBloc button { margin-top:40px; margin-right: auto; margin-left: auto; font-size:24px; display: block; min-width: 200px; padding:20px; background-color: rgb(var(--secondary)); font-weight: 700; text-transform: uppercase; }
        #fourthBloc button a { color: #FFF; font-family: TxtOffBDI; }
        #fourthBloc button:hover {box-shadow: 0px 0px 10px rgb(var(--primary)); cursor: pointer;}
        .errorMsg { color: rgb(var(--primary)); font-size: 14px; font-family: TxtOffRe; margin-top: 5px; padding-left: 0px; }
    /*#endregion */
    @media handheld, only screen and (max-width: 600px) {}
    @media handheld, only screen and (max-width: 960px) {
        .sectionTitle { font-size:24px; }
        .bgText {padding: 10px;}
        .futurBG { padding: 0px 10px;  }
        .boxForm { padding: 0px 20px !important; }
        .form input { width: 100%; }
        .form select { width: 100%; }
        .boximg {max-width: 150px;}
    }
    @media handheld, only screen and (max-width: 1279px) {}
    @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>

export default {
name: 'funding',
data:()=>({
    dealers: null,
    item: null,
    sendForm: null, // send, error, pending
    errors: {
        telephone: '',
        email: '',
        postalCode: '',
    },
    form: {
        nom: '',
        truckNew: null,
        idInventory: '',
        serialNumber: '',
        model: '',
        function: '',
        truckChoice: '',
        compagnie: '',
        telephone: '',
        town: '',
        email: '',
        address: '',
        comment: '',
        province: 'Quebec',
        postalCode: '',
        succursale: '',
    }
}),
async mounted() {
    this.dealersJsonRead();
    let NewKey = this.$route.params.New;
    if(NewKey) { this.form.truckNew = 1;}
    let truckKey = this.$route.params.id;

    if(truckKey ) {  await this.readData(truckKey,NewKey); } else{ }
    if(this.item) {
        this.form.model = this.item.modele;
        this.form.idInventory = this.item.noInventaire;
        this.form.serialNumber = this.item.noSerie;
    }
},
methods:{
    /** Lecture du JSON des concessionnaires */
    dealersJsonRead: async function () {
        try {
            const response = await fetch('/ressources/json/dealers.json');
            if (!response.ok) { throw new Error('Failed to fetch'); }
            this.dealers = await response.json();
        } catch (error) {
            console.error('Error loading dealers JSON:', error);
        }
    },
    /** Formate le téléphone en (XXX) XXX-XXXX et bloque les non-chiffres */
    formatTelephone: function() {
        let digits = this.form.telephone.replace(/\D/g, '');
        if (digits.length > 10) { digits = digits.substring(0, 10); }
        let formatted = '';
        if (digits.length > 0) { formatted = '(' + digits.substring(0, 3); }
        if (digits.length >= 3) { formatted += ') '; }
        if (digits.length > 3) { formatted += digits.substring(3, 6); }
        if (digits.length >= 6) { formatted += '-'; }
        if (digits.length > 6) { formatted += digits.substring(6, 10); }
        this.form.telephone = formatted;
        this.errors.telephone = '';
    },
    /** Valide le format du courriel */
    validateEmail: function() {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!this.form.email) {
            this.errors.email = 'Le courriel est requis.';
            return false;
        }
        if (!regex.test(this.form.email)) {
            this.errors.email = 'Le format du courriel est invalide.';
            return false;
        }
        this.errors.email = '';
        return true;
    },
    /** Valide le téléphone (10 chiffres avec indicatif régional) */
    validateTelephone: function() {
        const digits = this.form.telephone.replace(/\D/g, '');
        if (!digits) {
            this.errors.telephone = 'Le numéro de téléphone est requis.';
            return false;
        }
        if (digits.length < 10) {
            this.errors.telephone = 'Le numéro doit contenir 10 chiffres (indicatif régional inclus).';
            return false;
        }
        this.errors.telephone = '';
        return true;
    },
    /** Formate le code postal en A1A 1A1 (majuscules, lettres et chiffres alternés) */
    formatPostalCode: function() {
        let raw = this.form.postalCode.toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (raw.length > 6) { raw = raw.substring(0, 6); }
        let formatted = '';
        for (let i = 0; i < raw.length; i++) {
            // Positions 0, 2, 4 = lettres | Positions 1, 3, 5 = chiffres
            if (i % 2 === 0) {
                if (/[A-Z]/.test(raw[i])) { formatted += raw[i]; }
            } else {
                if (/[0-9]/.test(raw[i])) { formatted += raw[i]; }
            }
            if (formatted.length === 3 && !formatted.includes(' ')) { formatted += ' '; }
        }
        this.form.postalCode = formatted;
        this.errors.postalCode = '';
    },
    /** Valide le code postal canadien (format A1A 1A1) */
    validatePostalCode: function() {
        const regex = /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/;
        if (!this.form.postalCode) {
            this.errors.postalCode = 'Le code postal est requis.';
            return false;
        }
        if (!regex.test(this.form.postalCode)) {
            this.errors.postalCode = 'Le format doit être A1A 1A1.';
            return false;
        }
        this.errors.postalCode = '';
        return true;
    },
    /** Valide tout le formulaire avant soumission */
    validateAndSubmit: function() {
        const telValid = this.validateTelephone();
        const emailValid = this.validateEmail();
        const postalValid = this.validatePostalCode();
        if (telValid && emailValid && postalValid) {
            this.$refs.formFunding.submit();
        }
    },
    async readData(truckKey, NewKey) {

        //let api = '/ressources/api/singleUsedTruck_.php';
        let api = 'https://reseaudynamique.com/ressources/api/singleUsedTruck_.php';
        let isNew = null;
        if(NewKey) { isNew = 1;}
        
        if(isNew && isNew == 1){
            //api = '/ressources/api/singleNewTruck_.php';
            api = 'https://reseaudynamique.com/ressources/api/singleNewTruck_.php';
            this.isNew = 1;
        }

        let id = truckKey;
        if (id) {
            // Show loading spinner
            //$('.loading-overlay').show();

            try {
                const response = await fetch(api + '?id=' + id)
                const data = await response.json()
                this.item = data;

            } catch (error) {
                console.error(error);
                this.errorMessage = error.toString();
            }

            // Hide loading spinner
            //$('.loading-overlay').hide();
        }
    },
},
components: { }
}
</script>